import tablelistApi from 'api/tablelistApi'

export default {
  listByUserId(userId, options) {
    if (!userId) throw new Error('userId is required')

    return tablelistApi.get(`/user/${userId}/payment-profile`, options)
  },
  create(options) {
    if (!options) throw new Error('options is required')

    return tablelistApi.post('/paymentProfile', options)
  },
  updateById(id, options) {
    if (!id) throw new Error('id is required')
    if (!options) throw new Error('options is required')

    return tablelistApi.put(`/paymentProfile/${id}`, options)
  },
}



// WEBPACK FOOTER //
// ./src/api/paymentProfile/service.js